/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type NextHubReturnFragment = {
  __typename?: 'Vehicle'
  fccNextHubReturn: {
    __typename?: 'FccWaypointHubReturnAction'
    reason: Types.FccWaypointHubReturnReason
    promisedTimeRange: { __typename?: 'DateTimeInterval'; from: string }
    area: { __typename?: 'Area'; id: string } | null
  } | null
}

export const NextHubReturnFragmentDoc = gql`
    fragment NextHubReturn on Vehicle {
  fccNextHubReturn {
    reason
    promisedTimeRange {
      from
    }
    area {
      id
    }
  }
}
    `
